import { render, staticRenderFns } from "./baojingshijian.vue?vue&type=template&id=036bbcdd&scoped=true"
import script from "./baojingshijian.vue?vue&type=script&lang=js"
export * from "./baojingshijian.vue?vue&type=script&lang=js"
import style0 from "./baojingshijian.vue?vue&type=style&index=0&id=036bbcdd&prod&lang=scss"
import style1 from "./baojingshijian.vue?vue&type=style&index=1&id=036bbcdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036bbcdd",
  null
  
)

export default component.exports